import { render } from "./Styleguide-FieldUsage-File.vue?vue&type=template&id=b32042cc"
import script from "./Styleguide-FieldUsage-File.vue?vue&type=script&lang=js"
export * from "./Styleguide-FieldUsage-File.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__